module.exports = __webpack_public_path__ + "img/trabajo_pirque.368cb1bb.png";